(function () {
  'use strict';
  var CFG = {
    debug: false,
    elementName: 'cart-coupon',
    maxCodes: 5
  };

  var TAG = 'salepify-july-coupon-merge';

  function log() {
    if (!CFG.debug) return;
    console.log.apply(console, ['[' + TAG + ']'].concat(Array.prototype.slice.call(arguments)));
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function splitCodes(value) {
    return String(value == null ? '' : value)
      .split(',')
      .map(function (c) { return c.trim(); })
      .filter(Boolean);
  }

  function mergeCodes(existing, incoming) {
    var out = [];
    splitCodes(existing.join ? existing.join(',') : existing)
      .concat(splitCodes(incoming))
      .forEach(function (code) {
        if (out.indexOf(code) === -1) out.push(code);
      });
    var kept = out.slice(0, CFG.maxCodes);
    if (kept.length < out.length) {
      console.warn('[' + TAG + '] cart đã đủ ' + CFG.maxCodes + ' code, bỏ qua:', out.slice(CFG.maxCodes));
    }
    return kept;
  }

  function applicableCodes() {
    return fetch(root() + 'cart.js?' + TAG, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.discount_codes || [])
          .filter(function (d) { return d && d.applicable; })
          .map(function (d) { return d.code; });
      });
  }

  var REQUIRED = ['applyAndRender', 'postDiscount', 'fetchAndRenderSections'];

  function patchPrototype(proto) {
    if (!proto || proto[TAG]) return false;

    // Theme đổi API -> không patch, để nguyên hành vi gốc còn hơn làm chết nút apply.
    var missing = REQUIRED.filter(function (name) { return typeof proto[name] !== 'function'; });
    if (missing.length) {
      console.warn('[' + TAG + '] bỏ qua, <' + CFG.elementName + '> thiếu method:', missing);
      return false;
    }

    var originalApply = proto.applyAndRender;

    // Gộp code đang có trong cart vào trước khi để theme gửi đi.
    proto.applyAndRender = function (discount) {
      var self = this;
      return applicableCodes()
        .then(function (existing) { return mergeCodes(existing, discount); })
        .catch(function (e) { log('không đọc được cart.js, giữ nguyên code gõ vào', e); return splitCodes(discount); })
        .then(function (codes) {
          log('apply', codes);
          return originalApply.call(self, codes.join(','));
        });
    };

    // Gửi 1 lần list còn lại thay vì clear rồi apply từng cái.
    proto.removeSingleCode = function (codeToRemove) {
      var self = this;
      return applicableCodes()
        .then(function (existing) {
          var remaining = existing.filter(function (code) { return code !== codeToRemove; });
          log('remove', codeToRemove, '-> còn', remaining);
          return self.postDiscount(remaining.join(','));
        })
        .then(function () { return self.fetchAndRenderSections(); });
    };

    proto[TAG] = true;
    return true;
  }

  function install() {
    if (!window.customElements || !window.customElements.whenDefined) return;
    window.customElements.whenDefined(CFG.elementName)
      .then(function () {
        var ctor = window.customElements.get(CFG.elementName);
        if (patchPrototype(ctor && ctor.prototype)) log('đã patch <' + CFG.elementName + '>');
      })
      .catch(function (e) {
        console.warn('[' + TAG + '] không patch được, theme giữ nguyên hành vi gốc', e);
      });
  }

  window.SalepifyJulyCouponMerge = {
    mergeCodes: mergeCodes,
    splitCodes: splitCodes,
    patchPrototype: patchPrototype,
    install: install,
    config: CFG
  };

  try {
    install();
  } catch (e) {
    console.warn('[' + TAG + '] install lỗi, theme giữ nguyên hành vi gốc', e);
  }
})();
